import { isArray } from 'lodash';
import numeral from 'numeral';

export function formatValue(num) {
	return num < 10000 && num > 999 ? numeral(num).format('0.0a') : numeral(num).format('0a');
}

export function formatDigitLength(num, digitLength) {
	if (typeof num.toPrecision !== 'function') return num;
	return numeral(num.toPrecision(digitLength)).format('0[.][00]a');
}

export function couldBeDate(thing: string): boolean {
	// it could just be a number tough
	return !isNaN(Date.parse(thing))
	// return moment.isDate(thing)
}

export function isIsoDate(thing: string): boolean {
	// https://stackoverflow.com/a/37563868/5648839
	var ISO_8601_FULL = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i
	return ISO_8601_FULL.test(thing)
}

export function preformatNumber(thing: string): string {
	return thing.replace(/,/g, "") // replace 12,345,678.00 commas for better parsing.
}

export function isNumber(thing: string): boolean {
	return !isNaN(Number(preformatNumber(thing)))
}

export function isURL(thing: string): boolean {
	try {
		const url = new URL(thing)
		return true
	} catch {
		return false
	}
}

export function isObject(thing: any): boolean {
	return (!isArray(thing) && typeof thing === 'object')
}

/** transforms all keys in an object based on fn, and returns a new object */
export function objectMap<T = any, R = any>(
	obj: Record<string, T>,
	fn: (value: T, key: string, index: number) => R
) {
	// https://stackoverflow.com/a/14810722/5648839
	return Object.fromEntries(
		Object.entries(obj).map(
			([k, v], i) => [k, fn(v, k, i)]
		)
	)
}

export interface Rectangle {
	x: number;
	y: number;
	height: number;
	width: number;
}

/**
 * Returns true if the given rect intersects with any in the given list of rects
 * @param test
 * @param list
 * @returns {boolean|*}
 */
export const intersectsAny = (test: Rectangle, list: Rectangle[]): boolean => {
	if (list.length === 0) return false;

	return list.some((l) => {
		return intersectRect(test, l);
	});
}

/**
 * Tests if the two given rects intersect
 * @param r1
 * @param r2
 */
export const intersectRect = (r1: Rectangle, r2: Rectangle) => {
	return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.height || r2.y + r2.height < r1.y);
}
